/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */

/* eslint-disable sort-keys */

const PortletConstants = {

	// Portlet mode

	EDIT: 'edit',
	HELP: 'help',
	VIEW: 'view',

	// Window state

	MAXIMIZED: 'maximized',
	MINIMIZED: 'minimized',
	NORMAL: 'normal',

	// Resource URL cacheability

	FULL: 'cacheLevelFull',
	PAGE: 'cacheLevelPage',
	PORTLET: 'cacheLevelPortlet',
};

export {PortletConstants};
export default PortletConstants;
